<template>
  <base-temp
    id="consultationTemp"
    :title="$t('Phiếu khám bệnh')"
    :form-data="formData"
    :save_pdf="save_pdf"
    :check-lang="checkLang"
  >
    <div class="mb-8" v-if="form">
      <div class="mb-3">
        <div class="font-bold mb-2">{{ $t('Lý do khám bệnh') }}</div>
        <div class="hodo-table" v-if="form.consultation.reason" v-html="form.consultation.reason"></div>
      </div>
      <div class="mb-3">
        <div class="font-bold mb-2">{{ $t('Diễn biến') }}</div>
        <div
          class="hodo-table"
          v-if="form.consultation.progression"
          v-html="form.consultation.progression"
        ></div>
      </div>
      <div class="mb-3">
        <div class="font-bold mb-2">{{ $t('Chẩn đoán') }}</div>
        <div
          class="hodo-table"
          v-if="form.consultation.diagnose"
          v-html="form.consultation.diagnose"
        ></div>
      </div>
      <div class="mb-3">
        <div class="font-bold mb-2">{{ $t('Kết luận') }}</div>
        <div
          class="hodo-table"
          v-if="form.consultation.prehistoric"
          v-html="form.consultation.prehistoric"
        ></div>
      </div>
    </div>
  </base-temp>
</template>

<script>
import appUtils from '../../../utils/appUtils'
import mdtUtils from '../../../utils/mdtUtils'
import { mixinPrint } from '../../../utils/mixinPrint'
import BaseTemp from '../../BaseTemp.vue'

export default {
  name: 'PhieuKhamBenhV2',
  mixins: [mixinPrint],
  props: {
    formData: {
      type: Object,
      required: true
    },
    save_pdf: {
      type: Number,
      required: true
    },
    checkLang: {
      type: Number
    }
  },
  components: {
    BaseTemp
  },
  data () {
    return {
      loading: false,
      form: null,
      appUtils,
      mdtUtils
    }
  },
  mounted () {
    if (this.formData) {
      this.form = this.formData
    }
  },
  computed: {},
  watch: {
    formData (data) {
      this.form = data
    }
  },
  methods: {}
}
</script>

<style lang="scss" scoped>
::v-deep {
  body,
  html {
    font-family: "Times New Roman", Tinos, Times, serif !important;
  }

  p {
    margin-top: 0;
  }

  .relative {
    position: relative;
  }

  .absolute {
    position: absolute;
  }

  .top-0 {
    top: 0;
  }

  .left-0 {
    left: 0;
  }

  .block {
    display: block;
  }

  .inline-block {
    display: inline-block !important;
  }

  .flex {
    display: flex;
  }

  .flex-col {
    flex-direction: column;
  }

  .align-top {
    vertical-align: top;
  }

  .text-center {
    text-align: center;
  }

  .uppercase {
    text-transform: uppercase;
  }

  .capitalize {
    text-transform: capitalize;
  }

  .justify-center {
    justify-content: center;
  }

  .justify-between {
    justify-content: space-between;
  }

  .items-start {
    align-items: flex-start;
  }

  .items-center {
    align-items: center;
  }

  .w-full {
    width: 100% !important;
  }

  .w-half {
    width: 50% !important;
  }

  .w-one-third {
    width: 33.333% !important;
  }

  .font-bold {
    font-weight: 700;
  }

  .text-xs {
    font-size: 0.75rem;
    line-height: 1rem;
  }

  .text-sm {
    font-size: 0.875rem;
    line-height: 1.25rem;
  }

  .text-xl {
    font-size: 1.25rem;
    line-height: 1.75rem;
  }

  .pl-12 {
    padding-left: 3rem;
  }

  .pl-16 {
    padding-left: 4rem;
  }

  .pr-12 {
    padding-right: 3rem;
  }

  .pr-16 {
    padding-right: 4rem;
  }

  .mt-6 {
    margin-top: 1.5rem;
  }

  .mt-8 {
    margin-top: 2rem;
  }

  .mt-12 {
    margin-top: 3rem;
  }

  .mt-16 {
    margin-top: 4rem;
  }

  .mt-24 {
    margin-top: 6rem;
  }

  .mr-1 {
    margin-right: 0.25rem;
  }

  .mb-0 {
    margin-bottom: 0;
  }

  .mb-1 {
    margin-bottom: 0.25rem;
  }

  .mb-2 {
    margin-bottom: 0.5rem;
  }

  .mb-3 {
    margin-bottom: 0.75rem;
  }

  .mb-6 {
    margin-bottom: 1.5rem;
  }

  .mb-8 {
    margin-bottom: 2rem;
  }
  .hodo-table figure {
    margin: 0 0 1rem !important;
  }
  .hodo-table table {
    border-collapse: collapse !important;
    width: 100% !important;
    border: 1px solid #dbdde0 !important;
    margin-top: 1rem !important;
  }
  .hodo-table table thead th {
    text-transform: uppercase !important;
  }
  .hodo-table table th,
  .hodo-table table td {
    padding: 8px !important;
    border: 1px solid #dbdde0 !important;
  }
}
</style>
